import React from 'react';
import { MapPin, Calendar, Users, ChevronDown, X, Info } from 'lucide-react';
import './travelInsured.css';
import Nav from '../NavBar/Nav';
import FooterNew from '../NavBar/FooterNew';
import TravelQuoteForm from './TravelQuoteForm';


const TravelProtectionUI = () => {
  return (
    <div>
      <Nav />
      
      <div className="main-wrapper">
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content travel-container">
          <div className="book-travel-wrapper">
            <div className="accent-top-left"></div>
            <h1>
              Let's Get Your Trip<br />
              <span className="highlight">PROTECTED</span>
            </h1>
            <div className="accent-bottom-right"></div>
          </div>
        </div>
      </section>

      {/* TRENDING DESTINATIONS SECTION */}
      <section className="trending-section travel-container">
        <h2>Trending Destinations</h2>
        <div className="destinations-grid">
          <div className="destination-card">
            <img src="https://app.travelinsured.com/assets/images/defaultImage1.jpeg" alt="Paris" />
            <div className="card-label">Paris</div>
          </div>
          <div className="destination-card">
            <img src="https://app.travelinsured.com/assets/images/defaultImage2.jpeg" alt="Hoi An" />
            <div className="card-label">Hoi An</div>
          </div>
          <div className="destination-card">
            <img src="https://app.travelinsured.com/assets/images/defaultImage3.jpeg" alt="Canada" />
            <div className="card-label">Canada</div>
          </div>
          <div className="destination-card">
            <img src="https://app.travelinsured.com/assets/images/defaultImage4.jpeg" alt="Australia" />
            <div className="card-label">Australia</div>
          </div>
        </div>
      </section>

      {/* FLOATING FORM CARD */}
      <div className="form-container">
       <TravelQuoteForm/>
      </div>
      </div>
      

      <FooterNew/>
    </div>
    
  );
};

export default TravelProtectionUI;